import { Box, Typography } from '@mui/material';

const LabelValue = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <Box display="flex">
    <Typography color="textSecondary" width={120} flexShrink={0}>
      {label}
    </Typography>
    <Typography variant="body1">{value}</Typography>
  </Box>
);

export default LabelValue;
